import { css } from '@emotion/react';
import { useRef, useEffect } from 'react';
import { typography } from '../foundations';

interface CheckboxProps {
  id: string;
  name: string;
  value: string;
  label?: string;
  color: InputTextColors;
  disabled?: boolean;
  checked?: boolean;
  indeterminate?: boolean;
  className?: string;
}

export enum InputTextColors {
  Light = '#5E6C84',
  Dark = '#172B4D'
}

const textStyle = (color: InputTextColors) => css`
  color: ${color};
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  margin-left: 8px;
`;

const checkboxStyle = css`
  accent-color: blue;
  vertical-align: middle;
`;

const containerStyle = css`
  display: flex;
  input:hover,
  input:focus {
    cursor: pointer;
    background-color: #dfe1e6;
  }
`;

export const Checkbox = (props: CheckboxProps) => {
  const {
    id,
    name,
    value,
    label,
    color,
    disabled,
    checked,
    indeterminate,
    className
  } = props;
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (ref.current) {
      if (checked) {
        ref.current.checked = checked;
      } else if (indeterminate) {
        ref.current.indeterminate = indeterminate;
      }
    }
  }, [props]);

  return (
    <div className={className} css={[containerStyle, typography]}>
      <input
        type="checkbox"
        css={checkboxStyle}
        ref={ref}
        name={name}
        value={value}
        disabled={disabled || false}
      ></input>
      {label && (
        <label css={textStyle(color)} htmlFor={id}>
          {label}
        </label>
      )}
    </div>
  );
};
